export default "__VITE_ASSET__Rol2TqVX__"